import { fileViewerAtom, previewKeyAtom } from 'js/file_viewer/core/atoms/atom';
import { currentPreviewKeyAtom } from 'js/file_viewer/core/atoms/metadata';
import { zoom } from 'js/file_viewer/core/atoms/utils/zoom';
/**
 * Scale factor so that content fits to viewport
 */
export const fitScaleFactorAtom = previewKeyAtom(0);
/**
 * scaleFactor to fit by viewport's width (Fit to width)
 * calculated when doc/image loads on preview
 */
export const fitToWidthScaleFactorAtom = previewKeyAtom(0);
const zoomTypeInternalAtom = previewKeyAtom('fitToPage');
const manualZoomPercentInternalAtom = previewKeyAtom(undefined);
/**
 * Current zoom scale. If the user has manually zoomed, this will be the manual zoom scale. By default it's the scale
 * at which the image/page fits the screen.
 */
export const zoomPercentAtom = fileViewerAtom((get) => {
    var _a;
    const previewKey = get(currentPreviewKeyAtom);
    const zoomType = get(zoomTypeInternalAtom(previewKey));
    switch (zoomType) {
        case 'fitToWidth':
            return get(fitToWidthScaleFactorAtom(previewKey));
        case 'zoomPercent':
            return ((_a = get(manualZoomPercentInternalAtom(previewKey))) !== null && _a !== void 0 ? _a : get(fitScaleFactorAtom(previewKey)));
        default:
            return get(fitScaleFactorAtom(previewKey));
    }
}, (get, set, payload) => {
    const previewKey = get(currentPreviewKeyAtom);
    set(zoomTypeInternalAtom(previewKey), payload.zoomType);
    if (payload.zoomType === 'zoomPercent') {
        set(manualZoomPercentInternalAtom(previewKey), payload.newZoom);
    }
});
/**
 * Setting this atom will increment or decrement the zoom scale factor.
 * Set to true to zoom in, false to zoom out.
 */
export const zoomInOrOutAtom = fileViewerAtom(null, (get, set, zoomIn) => {
    const previewKey = get(currentPreviewKeyAtom);
    const currentZoom = get(zoomPercentAtom);
    const fitScaleFactor = get(fitScaleFactorAtom(previewKey));
    const newZoom = zoom({
        scaleFactor: currentZoom,
        ascend: zoomIn,
        fitScaleFactor,
    });
    set(zoomPercentAtom, { newZoom, zoomType: 'zoomPercent' });
});
export const isCurrentPreviewZoomedAtom = fileViewerAtom((get) => {
    const previewKey = get(currentPreviewKeyAtom);
    const currentZoom = get(zoomPercentAtom);
    const fitScaleFactor = get(fitScaleFactorAtom(previewKey));
    return !!currentZoom && currentZoom > fitScaleFactor;
});
//# sourceMappingURL=zoom.preenvesnextjs.map
